module.exports = __webpack_public_path__ + "static/devices-21891db192fd4f409e47c274e5e11cd8.png";